import React, { Suspense, lazy } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";

const MyVideos = lazy(() => import("./pages/MyVideos/MyVideos"));
const MyAdvertising = lazy(() => import("./pages/MyAdvertising/MyAdvertising"));
const MyScripts = lazy(() => import("./pages/MyScripts/MyScripts"));
/* const MyGoal = lazy(() => import("./pages/MyGoal/MyGoal"));
const MyRewards = lazy(() => import("./pages/MyRewards/MyRewards")); */
const MyDeal = lazy(() => import("./pages/MyDeal/MyDeal"));
const Users = lazy(() => import("./pages/Users/Users"));
const MySettings = lazy(() => import("./pages/MySettings/MySettings"));
const Plans = lazy(() => import("./pages/Plans/Plans"));
const PlansAndPayment = lazy(() => import("./pages/PlansAndPayment"));
const MyStatistics = lazy(() => import("./pages/MyStatistics/MyStatistics"));
const UpdateBillingInfo = lazy(() => import("./pages/UpdateBillingInfo"));
const CouponCodes = lazy(() => import("./pages/CouponCodes"));
const MyReferral = lazy(() => import("./pages/MyReferral"));
const MapParent = lazy(() => import("./pages/MapParent"));

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/my-videos" />
        }
        <ContentRoute path="/my-videos" component={MyVideos} />
        <ContentRoute path="/my-advertising" component={MyAdvertising} />
        <ContentRoute path="/my-scripts" component={MyScripts} />
        {/* <ContentRoute path="/my-goal" component={MyGoal} />
        <ContentRoute path="/my-rewards" component={MyRewards} /> */}
        <ContentRoute path="/my-deal" component={MyDeal} />
        <ContentRoute path="/users" component={Users} />
        <ContentRoute path="/plans" component={Plans} />
        <ContentRoute path="/plans-and-payment" component={PlansAndPayment} />
        <ContentRoute path="/my-settings" component={MySettings} />
        <ContentRoute path="/my-statistics" component={MyStatistics} />
        <ContentRoute path="/update-billing-info/:page?" component={UpdateBillingInfo} />
        <ContentRoute path="/coupon-codes" component={CouponCodes} />
        <ContentRoute path="/my-referral" component={MyReferral} />
        <ContentRoute path="/map-test" component={MapParent} />
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
